import DCMTagOverlay from "./DCMTagOverlay";
export { DCMTagOverlay as default };
